<template>
    <v-container fluid>   

        <v-col>
            <v-row class="pl-4 headline">{{ item.title }}</v-row>
        </v-col>

        <!-- Table with Pricelists Rows -->
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat :value="[0]">
                    <PricelistsRowsReadOnlyPanel :pricelistsAlvId="item.alvId"/>
                </v-expansion-panels>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

    import PricelistsRowsReadOnlyPanel from './_panels/1_pricelistsrows/PricelistsRowsReadOnlyPanel'

    export default {
        name: "PricelistsReadOnly",
        components: {
            PricelistsRowsReadOnlyPanel
        },
        props: {
            itemId: {
                type: Number
            }
        },
        computed: {
            item() {
                let item = this.$store.getters.getExpandedPricelists.find(element => {
                    return element.id === this.itemId
                })
                return item
            }
        },
    }
</script>